<div class="ad-upload-container" [ngClass]="{'a-upload-only-btn':onlyButton}">
    <div class="ad-upload-header">
        <input type="file" ng2FileSelect [uploader]="uploader" style="display: none;" #file />
        <ad-button (onClick)="selectFile()">{{text}}</ad-button>
    </div>
    <div class="ad-upload-list" *ngIf="!onlyButton&&uploader?.queue?.length>0">
        <ul>
            <li class="ad-upload-progress" *ngIf="uploader.isUploading||uploader.progress>0">
                <ad-line-loading [(ngModel)]="uploader.progress"></ad-line-loading><span
                    class="ad-upload-progress-num">{{uploader.progress}}%</span>
            </li>
            <li class="ad-upload-list-item" *ngFor="let item of uploader?.queue">
                <span class="ad-upload-name">{{ item?.file?.name }}</span>
                <span class="ad-upload-size">- {{ getFileSize(item)}}KB</span>
                <span class="ad-upload-actions"><i class="fa fa-times" (click)="item.remove()"></i></span>
            </li>
        </ul>
        <!-- <ad-button (onClick)="uploadAll()" [disabled]="!uploader.getNotUploadedItems().length">Upload all
        </ad-button> -->
    </div>
</div>